// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OfferSessionOrderResponse

import { OfferSessionOrderStrategy } from './enums.gen';

export type OfferSessionOrderApiResponse = {
	id: number;
	orderId: number;
	strategy: OfferSessionOrderStrategy;
	sessionIds: string[];
};

export type OfferSessionOrder = {
	id: number;
	orderId: number;
	strategy: OfferSessionOrderStrategy;
	sessionIds: string[];
};

export function hydrateOfferSessionOrder(data: OfferSessionOrderApiResponse): OfferSessionOrder {
	return { ...data };
}